export const phoneApp = {
  dialPhoneNumber(phoneNumber: string) {
    window.open('tel:' + phoneNumber);
  },

  openMap(address: string) {
    if (usePlatformStore().isIos) {
      if (useSettingsStore()._settings.defaultMap === MapSetting.apple) {
        window.open(`http://maps.apple.com/?address=${address}`);
      }

      if (useSettingsStore()._settings.defaultMap === MapSetting.google) {
        window.open(`https://www.google.com/maps/search/?api=1&query=${address}`);
      }
    } else {
      window.open(`https://www.google.com/maps/search/?api=1&query=${address}`);
    }
  },

  openMail(mail: string) {
    window.open('mailto:' + mail);
  },

  openWiki() {
    const wikiLink = 'https://e-komplet.dk/wiki/app-2/';
    window.open(wikiLink);
  },

  openKlarpris(projectName: string, projectReference: string) {
    const url = `https://app.klarpris.dk/?basketName=${encodeURIComponent(projectName)}&Reference=${encodeURIComponent(projectReference)}`;
    window.open(url, '_system');
  },

  openLink(link: string) {
    window.open(link);
  }
};
